import Link from 'redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import PlusSolidIcon from '@simplywallst/ui-core/icons/PlusSolid';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { ROUTE_DEPRECATED_IMPORT_PORTFOLIO } from '@/constants/routes';
import { useIsMobileScreen } from '@/hooks/useMedia';
import loadable from '@loadable/component';
import { Heading } from '@simplywallst/ui-core/next';

const Unavailable = loadable(() => import('./Unavailable'), {
  resolveComponent: (c) => c.Unavailable,
});

export const NewLegacyPortfolio = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return (
    <div
      className="grid gap-x2 sm:gap-x3 h-full @7xl/newPortfolio:h-auto content-between"
      data-cy-id="portfolio-legacy-creation"
    >
      <div className="grid gap-x1_25">
        <Heading as="h2">Want to track every transaction?</Heading>
        <div className="text-xs text-softer text-pretty max-w-[45ch]">
          Use our legacy portfolio for now. We’ll help you quickly transfer to a
          new portfolio when transaction support is ready.
        </div>
      </div>
      {isMobileScreen && RUNTIME_ENV === 'native' ? (
        <Unavailable />
      ) : (
        <Button
          as={Link}
          to={{ type: ROUTE_DEPRECATED_IMPORT_PORTFOLIO }}
          styleType="gentleLarge"
          alignIcon="left"
          className="w-fit focus-visible:ring-2 focus-visible:duration-0 focus-visible:ring-accent"
        >
          Legacy portfolio
          <PlusSolidIcon />
        </Button>
      )}
    </div>
  );
};
